module.exports = __webpack_public_path__ + "img/logo-keyvue-premium.46e75102.svg";